/** Returns appropriate color for the border between the buttons. */
export function getInnerBorderColor(props) {
    const { disabled, variant } = props;
    if (disabled)
        return 'disabled.border';
    return `${variant}`;
}
